import React, { useState } from 'react'
import { useQuery, useLazyQuery } from '@apollo/client'
import { Button, Grid, Dimmer, Loader } from 'semantic-ui-react'
import PaymentTable from '../components/Payments/PaymentTable'
import LoadingSpinner from '../components/LoadingSpinner'
import Pagination from '../components/Pagination'
import { LOAD_TRANSACTIONS_QUERY } from '../graphql/transaction'
import { exportPayments } from '../utils/helpers'
import '../components/Payments/styles.css'

const ROW_PER_PAGE = 100
const EXPORT_LIMIT = 1000

const Payment = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [exporting, setExporting] = useState(false)

    const { data, loading } = useQuery(LOAD_TRANSACTIONS_QUERY, {
        variables: {
            pagination: {
                page: currentPage,
                per_page: ROW_PER_PAGE,
            },
        },
    })

    const [loadTransactions] = useLazyQuery(LOAD_TRANSACTIONS_QUERY)

    const headerName = [
        { name: 'Dexter Job ID', field: '_id' },
        { name: 'Stripe payment ID', field: 'paymentId' },
        { name: 'Stripe ID', field: 'stripe_id' },
        { name: 'Paid Date', field: 'createdAt' },
        { name: 'Expert', field: 'fullName' },
        { name: 'Company Name', field: 'companyName' },
        { name: 'Code', field: 'code' },
        { name: 'Amount', field: 'amount' },
        { name: 'Credit Card', field: 'isCredit' },
        { name: 'Payment Detail', field: 'description' },
    ]

    if (loading) return <LoadingSpinner />

    const totalCount = data.transactions.total
    const totalPages = Math.ceil(totalCount / ROW_PER_PAGE)
    const tableData = data.transactions.transactions
        .filter((t) => t.paymentId !== null)
        .filter((t) => t.job !== null)
        .map((transaction) => {
            const { job, paymentId } = transaction
            const { project, expert } = job
            return {
                ...transaction,
                _id: job.id,
                fullName: expert.fullName,
                companyName: transaction.team.name,
                code: project?.code,
                isCredit: paymentId.slice(0, 2) === 'ch' ? 'Yes' : '',
                stripe_id: expert?.stripeAccount.stripeId,
            }
        })

    const exportTransactions = async () => {
        setExporting(true)
        const iterations = parseInt(EXPORT_LIMIT / ROW_PER_PAGE)
        const promises = []
        for (let i = 1; i <= iterations; i++) {
            promises.push(
                loadTransactions({
                    variables: {
                        pagination: {
                            page: i + 1,
                            per_page: ROW_PER_PAGE,
                        },
                    },
                })
            )
        }
        try {
            const txns = []
            const results = await Promise.all(promises)
            results.forEach((result) => {
                if (result?.data?.transactions?.transactions) {
                    txns.push(...result.data.transactions.transactions)
                }
            })
            exportPayments(txns)
        } catch (err) {
            alert('Error exporting transactions:', err.message)
        }
        setExporting(false)
    }

    return (
        <div className="payment-page">
            <Dimmer active={exporting}>
                <Loader>Exporting... This may take up to a minute.</Loader>
            </Dimmer>
            <Grid columns={1}>
                <Grid.Column>
                    <h2>Payment history</h2>
                    <Button
                        size="tiny"
                        onClick={exportTransactions}
                        style={{ float: 'right' }}
                    >
                        Export
                    </Button>
                    <br />
                    <div className="payment-table">
                        <PaymentTable
                            headerName={headerName}
                            tableData={tableData}
                        />
                    </div>
                    <span className="pagination-data">
                        Total {totalCount} results | Page {currentPage} of{' '}
                        {totalPages}
                    </span>
                    <Pagination
                        defaultActivePage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                </Grid.Column>
            </Grid>
        </div>
    )
}

export default Payment
